<script setup>
import { watchEffect } from 'vue';
import { RouterView } from 'vue-router';
import { useToast } from 'primevue/usetoast';

import Toast from 'primevue/toast';

import PageLoader from '@/components/PageLoader.vue';

import useToastsStore from '@/stores/toasts';

const toast = useToast();

const { toastQueue, removeFromToastQueue } = useToastsStore();

const toastIconComponent = () => ({
  info: 'fa-regular fa-circle-info',
  success: 'fa-regular fa-check',
  warn: 'fa-regular fa-triangle-exclamation',
  error: 'fa-regular fa-circle-exclamation',
});

watchEffect(() => {
  if (toastQueue.length > 0) {
    for (let i = toastQueue.length - 1; i >= 0; i -= 1) {
      const toastMessage = toastQueue[i];
      toast.add(toastMessage);

      removeFromToastQueue(i);
    }
  }
});
</script>

<template>
  <PageLoader />
  <RouterView />
  <Toast group="link">
    <template #message="slotProps">
      <font-awesome-icon :icon="toastIconComponent()[slotProps.message.severity]" />
      <div class="p-toast-message-text" data-pc-section="text"><span class="p-toast-summary" data-pc-section="summary">{{ slotProps.message.summary }}</span><div class="p-toast-detail" data-pc-section="detail">{{ slotProps.message.detail }} <a :href="slotProps.message.linkHref">{{ slotProps.message.linkText }}</a></div></div>
    </template>
  </Toast>
</template>
